import { useQueryClient } from "react-query";
import { simpleRequest } from "core/services/api";
import { methodSchema } from "core/schemas/http";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import { useMutationWithErrorHandling } from "modules/shared/hooks/useMutationWithErrorHandling";
import { createImageBodySchema } from "../../schemas/createImageApiSchema";
import useFeedbackStore from "modules/feedback/hooks/useFeedbackStore";
import {
  actionsSchema,
  feedbackSchema,
} from "core/components/ActionFeedback/schemas/actionSchemas";

export const createImage = (formDataImage: FormData) =>
  simpleRequest(
    ENDPOINTS.IMAGES,
    createImageBodySchema,
    methodSchema.enum.post,
    formDataImage
  );

export const useCreateImage = () => {
  const queryClient = useQueryClient();
  const { setFeedback } = useFeedbackStore();
  return useMutationWithErrorHandling(createImage, {
    onError: (error: any) => {
      console.error("Upload error:", error);
      console.error("Error details:", error.response?.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["images"]);
      setFeedback(feedbackSchema.enum.success, actionsSchema.enum.saveImage);
    },
  });
};
